import axios from 'axios';
import { isNativeApp } from './isNativeApp';
import { emitNativeDebugEvent, normalizeAxiosError } from './nativeDebugEvents';

let installed = false;

export function installAxiosNativeDebug() {
  if (installed) return;
  installed = true;

  if (!isNativeApp()) return;

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      try {
        emitNativeDebugEvent(normalizeAxiosError(err));
      } catch {
        // no-op
      }
      return Promise.reject(err);
    }
  );

  // Cattura errori non gestiti (promise) e runtime
  window.addEventListener('unhandledrejection', (event) => {
    try {
      emitNativeDebugEvent({
        kind: 'unhandledrejection',
        detail: event?.reason?.message || String(event?.reason || 'Promise rejection')
      });
    } catch {
      // no-op
    }
  });

  window.addEventListener('error', (event) => {
    try {
      emitNativeDebugEvent({
        kind: 'error',
        detail: event?.message || 'Runtime error'
      });
    } catch {
      // no-op
    }
  });
}
